import { cn } from '@/lib/utils';

type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
  as?: 'p' | 'span' | 'div';
  withLine?: boolean;
};

export const Eyebrow = ({
  children,
  className,
  as: Tag = 'p',
  withLine = true,
}: EyebrowProps) => {
  return (
    <Tag
      className={cn(
        'text-brand-soft inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-widest',
        className
      )}
    >
      {withLine && (
        <span
          className="bg-brand-soft inline-block h-px w-5 shrink-0"
          aria-hidden="true"
        />
      )}
      {children}
    </Tag>
  );
};
